const PROJECT_ID_QUERY_KEY =
  "projectId";

function cleanText(value) {
  return String(value ?? "").trim();
}

function browserSearch() {
  if (typeof window === "undefined") {
    return "";
  }

  return String(
    window.location.search || ""
  );
}

export function currentProjectPathname(
  location =
    typeof window === "undefined"
      ? null
      : window.location
) {
  return cleanText(
    location?.pathname
  ).toLowerCase();
}

export function projectIdFromSearch(
  search = browserSearch()
) {
  const params =
    new URLSearchParams(
      String(search || "")
    );

  return cleanText(
    params.get(
      PROJECT_ID_QUERY_KEY
    )
  );
}

export function buildProjectPath(
  pathname,
  {
    search = "",
    projectId:
      requestedProjectId,
    clearProjectId = false,
  } = {}
) {
  const params =
    new URLSearchParams(
      String(search || "")
    );

  if (clearProjectId) {
    params.delete(
      PROJECT_ID_QUERY_KEY
    );
  }

  if (
    requestedProjectId !==
      undefined
  ) {
    const identity =
      cleanText(
        requestedProjectId
      );

    if (identity) {
      params.set(
        PROJECT_ID_QUERY_KEY,
        identity
      );
    } else {
      params.delete(
        PROJECT_ID_QUERY_KEY
      );
    }
  }

  const query =
    params.toString();

  return `${cleanText(pathname)}${
    query
      ? `?${query}`
      : ""
  }`;
}

export function replaceProjectPath(
  pathname,
  options = {}
) {
  if (typeof window === "undefined") {
    return "";
  }

  const nextPath =
    buildProjectPath(
      pathname,
      {
        ...options,

        search:
          options.search !==
            undefined
            ? options.search
            : browserSearch(),
      }
    );

  window.history.replaceState(
    {},
    "",
    nextPath
  );

  return nextPath;
}

export function buildProjectWorkspacePath(
  basePath,
  workspace,
  {
    foundationWorkspace =
      "foundation",
    search = "",
    projectId,
  } = {}
) {
  const identity =
    cleanText(workspace);

  const foundation =
    cleanText(
      foundationWorkspace
    ) || "foundation";

  const suffix =
    identity &&
    identity !== foundation
      ? `/${identity}`
      : "";

  return buildProjectPath(
    `${cleanText(basePath)}${suffix}`,
    {
      search,
      projectId,
    }
  );
}

export function replaceProjectWorkspacePath(
  basePath,
  workspace,
  options = {}
) {
  if (typeof window === "undefined") {
    return "";
  }

  const nextPath =
    buildProjectWorkspacePath(
      basePath,
      workspace,
      {
        ...options,

        search:
          options.search !==
            undefined
            ? options.search
            : browserSearch(),
      }
    );

  window.history.replaceState(
    {},
    "",
    nextPath
  );

  return nextPath;
}
